var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "19px",
    viewBox: "0 0 14 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gumb-App-(MVP)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Documentation_owner-inner_MVP-2_desktop",
    transform: "translate(-385.000000, -192.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-1",
    transform: "translate(361.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-string-desktop",
    transform: "translate(1.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5042796,12.69184 C36.8206851,13.0082454 36.9999678,13.4406594 36.9999678,13.8871496 L36.9999678,25.5624987 C36.9999678,26.4941371 36.2441102,27.2499946 35.3124718,27.2499946 L25.187496,27.2499946 C24.2558576,27.2499946 23.5,26.4941371 23.5,25.5624987 L23.5,10.9375335 C23.5,10.0058951 24.2558576,9.25003755 25.187496,9.24653567 L32.3628558,9.24653567 C32.8093459,9.24653567 33.238258,9.42581838 33.5546635,9.74222388 L36.5042796,12.69184 Z M35.1753491,13.7500268 L32.4999785,11.0746563 L32.4999785,13.7500268 L35.1753491,13.7500268 Z M25.187496,25.5624987 L35.3124718,25.5624987 L35.3124718,15.4375228 L31.6562306,15.4375228 C31.1886604,15.4375228 30.8124826,15.061345 30.8124826,14.5937748 L30.8124826,10.9375335 L25.187496,10.9375335 L25.187496,25.5624987 Z",
    id: "\\uF15B"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.1221c6c6.svg";
export { ForwardRef as ReactComponent };